import { render, staticRenderFns } from "./CategoryItems.vue?vue&type=template&id=86edefb6&scoped=true&"
import script from "./CategoryItems.vue?vue&type=script&lang=js&"
export * from "./CategoryItems.vue?vue&type=script&lang=js&"
import style0 from "./CategoryItems.vue?vue&type=style&index=0&id=86edefb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86edefb6",
  null
  
)

export default component.exports